function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import React from "react";

var _ref2 = /*#__PURE__*/React.createElement("g", {
  clipPath: "url(#clip0_1656_17098)"
}, /*#__PURE__*/React.createElement("path", {
  d: "M37.9799 19.8554C37.9799 18.2986 37.8506 17.1625 37.5708 15.9844H19.3784V23.0112H30.0569C29.8417 24.7574 28.6791 27.3873 26.0956 29.1544L26.0593 29.3897L31.8114 33.7441L32.21 33.783C35.8699 30.4799 37.9799 25.62 37.9799 19.8554Z",
  fill: "#1890FF"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.3784 38.3694C24.61 38.3694 29.002 36.6862 32.21 33.783L26.0956 29.1544C24.4594 30.2695 22.2633 31.0479 19.3784 31.0479C14.2545 31.0479 9.90556 27.7449 8.35529 23.1796L8.12805 23.1984L2.14694 27.7217L2.06873 27.9342C5.25505 34.1195 11.8 38.3694 19.3784 38.3694Z",
  fill: "#34A853"
}), /*#__PURE__*/React.createElement("path", {
  d: "M8.35529 23.1797C7.94624 22.0015 7.7095 20.7391 7.7095 19.4348C7.7095 18.1303 7.94624 16.868 8.33377 15.6899L8.32293 15.439L2.26687 10.843L2.06873 10.9351C0.755491 13.5019 0.00195312 16.3842 0.00195312 19.4348C0.00195312 22.4854 0.755491 25.3676 2.06873 27.9343L8.35529 23.1797Z",
  fill: "#FBBC05"
}), /*#__PURE__*/React.createElement("path", {
  d: "M19.3784 7.82139C23.0169 7.82139 25.4712 9.35721 26.8706 10.6407L32.3391 5.42304C28.9806 2.37245 24.61 0.5 19.3784 0.5C11.8 0.5 5.25505 4.74977 2.06873 10.9351L8.33377 15.6899C9.90556 11.1245 14.2545 7.82139 19.3784 7.82139Z",
  fill: "#EB4335"
}));

var _ref3 = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
  id: "clip0_1656_17098"
}, /*#__PURE__*/React.createElement("rect", {
  width: 38,
  height: 38,
  fill: "white",
  transform: "translate(0 0.5)"
})));

var SvgGoogle = function SvgGoogle(_ref) {
  var svgRef = _ref.svgRef,
      title = _ref.title,
      props = _objectWithoutProperties(_ref, ["svgRef", "title"]);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 38,
    height: 39,
    viewBox: "0 0 38 39",
    fill: "none",
    ref: svgRef
  }, props), title ? /*#__PURE__*/React.createElement("title", null, title) : null, _ref2, _ref3);
};

var ForwardRef = React.forwardRef(function (props, ref) {
  return /*#__PURE__*/React.createElement(SvgGoogle, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/google.d93c2ea6.svg";
export { ForwardRef as ReactComponent };